/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Uid_UniqueInputs */



/**
* | output |
* | --- |
* | "The gateway uid must be unique" |
*
* @param {Gateway_Uid_UniqueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_uid_unique = /** @type {((inputs?: Gateway_Uid_UniqueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Uid_UniqueInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The gateway uid must be unique")
	return /** @type {LocalizedString} */ ("Le uid de la box doit être unique")
});